import { handleActions } from 'redux-actions';
import { createAction } from '~reduxHelpers';

/**
 * ACTIONS
 */
export const openPrintView = createAction('OPEN_PRINT_VIEW');
export const closePrintView = createAction('CLOSE_PRINT_VIEW');

/**
 * REDUCERS
 */
const initialState = {
  printView: false,
  task: {},
  positionY: null,
};

export default handleActions(
  {
    OPEN_PRINT_VIEW: (state, action) => ({
      ...state,
      printView: true,
      task: action.payload.task,
      positionY: action.payload.positionY,
    }),
    CLOSE_PRINT_VIEW: state => ({
      ...state,
      printView: false,
    }),
  },
  initialState
);

/**
 * SELECTORS
 */
export const isPrintView = state => state.print.printView;
export const getTask = state => state.print.task;
export const getPositionY = state => state.print.positionY;

/**
 * THUNKS
 */
